<template>
  <div class="form-group" :class="{ 'form-group--error': validator.$error }">
    <loading-select v-if="isLoading" />
    <select v-else :disabled="!hasItems" v-model="validator.$model" class="form-control">
      <option value="" disabled selected>{{ disabledOptionText }}</option>
      <option v-for="item in displayItems"
        :key="item.id"
        :value="item" >
        {{ item.name }}
      </option>
    </select>
  </div>
</template>

<script>
import LoadingSelect from './LoadingSelect.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SelectRecipient',
  components: {
    LoadingSelect
  },
  props: {
    validator: Object,
    items: Array,
    placeholder: String,
    placeholderEmpty: String,
    isLoading: Boolean
  },
  computed: {
    displayItems() {
      return this.items || []
    },
    hasItems() {
      return this.items && this.items.length > 0;
    },
    disabledOptionText() {
      if (this.hasItems) {
        return this.placeholder;
      }
      return this.placeholderEmpty;
    }
  }
}
</script>

